export var iot_data = [
 {   
    "node_id" : 0,
    "temperature" : 125,
    "humidity" : 32,
    "current" :  10
 },
 {   
  "node_id" : 1,
  "temperature" : 140,
  "humidity" : 34,
  "current" :  14
},
{   
  "node_id" : 2,
  "temperature" : 88,
  "humidity" : 74,
  "current" :  42
},
{   
  "node_id" : 3,
  "temperature" : 55,
  "humidity" : 12,
  "current" :  20
}
];
